import { useState, useEffect } from 'react';
import css from './MoveUpButton.module.scss';
import { svgSprite } from '../../hybrid/wrappers';

const MoveUpButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        if (window.scrollY > 200) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        isVisible && (
            <div className={css.wrapper}>
                <button className={css.moveUpButton} onClick={handleClick}>
                    {svgSprite('moveUpBtn', {
                        width: '88',
                        height: '88'
                    })}
                </button>
            </div>
        )
    );
};

export default MoveUpButton;
